import styled from "@emotion/styled";
import {observer} from "mobx-react-lite";

type AlignProp = 'left' | 'center' | 'right';

interface ITabsProps {
    tabs: ITabData[];
    align?: AlignProp;
    noBorder?: boolean;
}

interface ITabData {
    id: string;
    title: string;
    count?: number;
    active?: boolean;
    onClick?: (id: string) => void;
}

interface IRootStyledProps {
    align?: AlignProp;
    noBorder?: boolean;
}

interface ITabStyledProps {
    active?: boolean;
}

const getTabAlign = (align?: AlignProp) => {
    switch(align) {
        case 'left':
            return 'flex-start';
        case 'right':
            return 'flex-end';
        case 'center':
        default:
            return 'center';
    }
};

const Root = styled.div<IRootStyledProps>`
    display: flex;
    justify-content: ${({align}) => getTabAlign(align)};
    font-size: 16px;
    font-weight: 500;
    border-bottom: ${({noBorder}) => noBorder ? 'none' : '1px solid #F1F2FE'};
`;

const Tab = styled.div<ITabStyledProps>`
    padding: 15px 2px;
    display: flex;
    margin-right: 24px;
    border-bottom: 3px solid ${({active}) => active ? '#7075E9' : 'transparent'};
    cursor: pointer;
`;

const TabName = styled.div<ITabStyledProps>`
    color: ${({active}) => active ? '#363870' : '#8082C5'};
    margin-right: 8px;
`;

const TabCount = styled.div<ITabStyledProps>`
    color: ${({active}) => active ? '#FFFFFF' : '#8082C5'};
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    padding: 2px 6px;
    background: ${({active}) => active ? '#7075E9' : '#F1F2FE'};
    border-radius: 4px;
`;

export default observer(function(props: ITabsProps) {
    return (
        <Root align={props.align} noBorder={props.noBorder}>
            {
                props.tabs.map((tab) => {
                    return <Tab
                        key={tab.id}
                        active={tab.active}
                        onClick={() => tab.onClick?.(tab.id)}>
                        <TabName active={tab.active}>{tab.title}</TabName>
                        {typeof tab.count === 'number' ? <TabCount active={tab.active}>{tab.count}</TabCount> : ''}
                    </Tab>
                })
            }
        </Root>
    );
});